import React, { useEffect, useState } from 'react';
import {
  Button,
  Spin,
  Modal,
  Form,
  Input,
  Radio,
  Select,
  notification,
} from 'antd';
import { LeftOutlined, PlusOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import map from 'lodash/map';
import find from 'lodash/find';
import { productMangement } from '../../redux/actions/productAction';

const { Option } = Select;

function AddProductProperty(props) {
  const { onSelectProductProperty, selectedProductProperty, companyId } = props;
  const [showLoginModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productProperty, setProductProperty] = useState([]);
  const [section, setSection] = useState(1);
  const dispatch = useDispatch();

  const toggleModal = () => {
    setShowModal(!showLoginModal);
  };

  const getProductProperty = () => {
    setLoading(true);
    dispatch(
      productMangement('list.product_property_types', {
        company_id: companyId,
      })
    )
      .then((result) => {
        setProductProperty(get(result, 'data'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSelectFinish = ({ id }) => {
    if (find(selectedProductProperty, ['id', id])) {
      notification.error({
        message: 'This Property is already selected!',
      });
      return;
    }
    onSelectProductProperty(find(productProperty, ['id', id]));
    toggleModal();
  };

  const onCreateFinish = (value) => {
    setLoading(true);
    dispatch(
      productMangement('create.product_property_type', {
        company_id: companyId,
        ...value,
      })
    )
      .then((result) => {
        onSelectProductProperty(get(result, 'data'));
        toggleModal();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showLoginModal) {
      getProductProperty();
    }
  }, [showLoginModal]);

  return (
    <>
      <Button
        className="add-categoty-link"
        icon={<PlusOutlined />}
        onClick={toggleModal}
        type="link"
      >
        Add Product Property
      </Button>
      <Modal
        width="50%"
        className="common-modal product-image-modal "
        destroyOnClose
        closable={false}
        open={showLoginModal}
        onOk={toggleModal}
        onCancel={toggleModal}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="login-container">
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleModal();
                }}
              />
              Add Product Property
            </div>
            <div className=" add-ingredient mt-40">
              <Radio.Group
                defaultValue={section}
                buttonStyle="solid"
                className="radio-btn"
                onChange={(e) => {
                  setSection(get(e, 'target.value'));
                }}
              >
                <Radio.Button value={1}>Select Product Property</Radio.Button>
                <Radio.Button value={2}>Create a Product Property</Radio.Button>
              </Radio.Group>
              {section === 1 && (
                <Form
                  name="basic"
                  layout="vertical"
                  initialValues={{ remember: true }}
                  onFinish={onSelectFinish}
                  autoComplete="off"
                  requiredMark={false}
                >
                  <div className="mt-20">
                    <Form.Item
                      label="Product Property"
                      name="id"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: 'Please select a product property!',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select Product Property"
                        size="large"
                      >
                        {map(productProperty, (prop) => (
                          <Option
                            key={get(prop, 'id')}
                            value={get(prop, 'id')}
                            label={get(prop, 'name')}
                          >
                            {get(prop, 'name')}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <div className="mt-40">
                      <Button type="primary" block htmlType="submit">
                        Select
                      </Button>
                    </div>
                  </div>
                </Form>
              )}

              {section === 2 && (
                <Form
                  name="basic"
                  layout="vertical"
                  onFinish={onCreateFinish}
                  autoComplete="off"
                  requiredMark={false}
                >
                  <div className="mt-20">
                    <Form.Item
                      label="Product Property"
                      name="name"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: 'Please input Property name!',
                        },
                        {
                          min: 3,
                          message:
                            'Property name  should be of atleast 3 character!',
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        placeholder="Enter Product Property"
                      />
                    </Form.Item>
                  </div>
                  <div className="mt-20">
                    <Form.Item
                      label="Description "
                      name="description"
                      className="form-item"
                    >
                      <Input size="large" placeholder="Description" />
                    </Form.Item>
                  </div>

                  <div className="mt-40">
                    <Button type="primary" block htmlType="submit">
                      Create
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
}

export default AddProductProperty;
